import React from 'react';
import { useApi } from '@root/src/web/lib/api';
import { Placeholder } from '@root/src/web/components/Placeholder';
import { MatchNav } from './MatchNav';
const Loading = () => React.createElement(Placeholder, { height: 230 });
export const GetMatchNav = ({ matchUrl }) => {
    const { data, error, loading } = useApi(matchUrl);
    if (loading)
        return React.createElement(Loading, null);
    if (error) {
        // Send the error to Sentry and then prevent the element from rendering
        window.guardian.modules.sentry.reportError(error, 'match-nav');
        return null;
    }
    if (data) {
        return (React.createElement(MatchNav, { homeTeam: data.homeTeam, awayTeam: data.awayTeam, comments: data.comments, minByMinUrl: data.minByMinUrl }));
    }
    return null;
};
